module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_8011.5e2138f5.png";